<script setup lang="ts">
import type {
	CuratedListSimilarPropertiesEmits,
	CuratedListSimilarPropertiesProps,
	NavigationTab,
	RegionTab
} from '.';

import { PropertyFiltersPresenter } from '~/presenters/PropertyFiltersPresenter';

import { StandardSlider } from '../StandardSlider';
import RegionTabsNavigator from './RegionTabsNavigator.vue';

const props = withDefaults(defineProps<CuratedListSimilarPropertiesProps>(), {
	containerClass: '',
	buttonVariant: 'primary',
	buttonClass: '',
	sectionName: 'similar properties',
	isLoading: false,
	title: 'Explore imóveis semelhantes a esta coleção'
});

const emit = defineEmits<CuratedListSimilarPropertiesEmits>();

const currentTab = defineModel<RegionTab>('currentTab');

const tabs = computed<NavigationTab[]>(() => {
	if (!props.uniqueRegions.length) return [];

	return props.uniqueRegions.map(
		(regionTab): NavigationTab => ({
			id: regionTab.region,
			label: regionTab.region,
			state: regionTab.state,
			city: regionTab.city,
			active: currentTab.value?.region === regionTab.region
		})
	);
});

function handleViewMoreClicked(href: string) {
	emit('cta-view-more-clicked', {
		destination_url: href,
		cta_text: 'Ver todos'
	});
}

const propertyHref = computed<string>(() => {
	const region = tabs.value.find(tab => tab.active)?.label;

	if (!region) return '';

	const href = PropertyFiltersPresenter.getPathFromFilters({
		states: [currentTab.value?.state ?? ''],
		cities: [currentTab.value?.city ?? ''],
		regions: [region]
	});

	return href;
});
</script>

<template>
	<section class="w-full bg-white">
		<StandardSlider
			:items="similarRegionProperties"
			:container-class="props.containerClass"
			:button-variant="buttonVariant"
			:button-class="buttonClass"
			:section-name="sectionName"
			:view-all-href="propertyHref"
			:title="title"
			:is-loading="isLoading"
			@cta-view-more-clicked="handleViewMoreClicked(propertyHref)"
		>
			<template #navigation>
				<RegionTabsNavigator
					v-model:active-tab="currentTab"
					:tabs="tabs"
					class="md:px-5 lg:px-0"
				/>
			</template>
		</StandardSlider>
	</section>
</template>
